import { NavLink } from "react-router-dom";
import { NAV } from "@/components/ranger/nav";
import { CommunitySwitcher } from "@/components/layout/CommunitySwitcher";
import { useAuth } from "@/context/AuthContext";

export const Brand = () => (
  <div className="flex items-center gap-3 px-5 py-5">
    <img src="/ranger-logo.jpg" alt="RANGER wolf emblem" className="h-10 w-10 rounded-sm border border-[#1E2D4A]" />
    <div>
      <div className="font-display text-xl font-bold uppercase leading-none tracking-[0.25em] text-slate-100">Ranger</div>
      <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#E5202E]/70">RCE Command</div>
    </div>
  </div>
);

export const Sidebar = ({ onNavigate }) => {
  const { user } = useAuth();
  return (
  <nav aria-label="Primary" className="flex h-full flex-col bg-[#070A14]">
    <Brand />
    <div className="px-4 pb-4"><CommunitySwitcher /></div>
    <div className="flex-1 space-y-6 overflow-y-auto px-3 pb-6">
      {NAV.map((g) => (
        <div key={g.group}>
          <div className="rg-label px-2 pb-2">{g.group}</div>
          <ul className="space-y-0.5">
            {g.items.filter((i) => !i.ownerOnly || user?.is_owner).map(({ path, label, icon: Icon, phase }) => (
              <li key={path}>
                <NavLink
                  to={path}
                  onClick={onNavigate}
                  data-testid={`nav-${path.slice(1)}`}
                  className={({ isActive }) =>
                    `group flex items-center gap-3 rounded-sm border-l-2 px-3 py-2 text-sm transition-colors ${
                      isActive
                        ? "border-[#E5202E] bg-[#E5202E]/10 text-white"
                        : "border-transparent text-slate-400 hover:bg-[#111A2E] hover:text-slate-200"
                    }`
                  }
                >
                  <Icon className="h-4 w-4 shrink-0" aria-hidden />
                  <span className="flex-1">{label}</span>
                  {phase && <span className="font-mono text-[9px] tracking-widest text-slate-600">P{phase}</span>}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </nav>
  );
};
